import { ILogger } from "../cityversetycoon/logger/ILogger";
import { VariableSaver } from "../tools/variableSaver/VariableSaver";
import { AnalyticEventType } from "./events/AnalyticEventType";
import { BaseAnalyticEvent } from "./events/BaseAnalyticEvent";
import { VirtualScreenEvent } from "./events/VirtualScreenEvent";
import { GameInfo } from "./GameInfo";
import { IAnalyticsProvider } from "./IAnalyticsProvider";
import { EventDto } from "./types/EventDto";

export class GoogleAnalyticsProvider implements IAnalyticsProvider {
    private readonly gameInfo: GameInfo;
    private readonly variableSaver: VariableSaver;
    private readonly logger: ILogger;

    public constructor(
        gameInfo: GameInfo,
        variableSaver: VariableSaver,
        logger: ILogger
    ) {
        this.gameInfo = gameInfo;
        this.variableSaver = variableSaver;
        this.logger = logger;
    }

    public registerEvent(baseEvent: BaseAnalyticEvent): void {
        switch (baseEvent.eventType) {
            case AnalyticEventType.VirtualScreenView:
                const guestId = this.variableSaver.getString("_CVT_GUEST_ID");
                const event = baseEvent as VirtualScreenEvent;
                const eventDto: EventDto = {
                    screen_name: event.screenName,
                    game_version: this.gameInfo.gameVersion,
                    user_id: guestId,
                    screen_index: event.screenIndex,
                    game_load_time: event.loadTime,
                    indication: event.indication
                };
                (window as any).gtag('event', event.eventType, eventDto);
                this.logger.info(`Google event: ${eventDto.screen_name}, screen_index: ${eventDto.screen_index}, user_id: ${guestId}, game_load_time: ${eventDto.game_load_time}, indication: ${eventDto.indication}`);
                break;
            default: throw new Error(`Event type: ${baseEvent.eventType} - not implemented.`);
        }
    }
}
